import { render, staticRenderFns } from "./im-session-forwardlist.vue?vue&type=template&id=80af78bc"
import script from "./im-session-forwardlist.vue?vue&type=script&lang=js"
export * from "./im-session-forwardlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80af78bc')) {
      api.createRecord('80af78bc', component.options)
    } else {
      api.reload('80af78bc', component.options)
    }
    module.hot.accept("./im-session-forwardlist.vue?vue&type=template&id=80af78bc", function () {
      api.rerender('80af78bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/im-layout/js/im-session-forwardlist.vue"
export default component.exports